import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { KEYS } from '@pos-app/data';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SecureCatalogueService {
  private isCatalogueVisible = new BehaviorSubject<boolean>(true);
  constructor(private router: ActivatedRoute) {
    const status = localStorage.getItem(KEYS.catalogueStatus);
    this.isCatalogueVisible.next(status ? JSON.parse(status).catalogueVisibleYN === 'Y' : false);
  }

  setIsCatalogueVisible(value: boolean) {
    this.isCatalogueVisible.next(value);
  }

  getIsCatalogueVisible() {
    return this.isCatalogueVisible.value;
  }

  getLandingPage(iframe = false) {
    if (iframe) {
      return this.isCatalogueVisible.value ? '/epc' : '/pos/customers/search';
    } else {
      return '/central';
    }
    // return this.isCatalogueVisible.value ? '/epc' : '/pos/customers/search';
  }
  getEpclandingPage() {
    return this.isCatalogueVisible.value ? '/epc' : '/pos/customers/search';
  }
  getEpclandingPageForNewOrder(orderType?: string): string {
    return this.isCatalogueVisible.value ? `/epc?newOrder=true&orderType=${orderType}` : '/pos/customers/search';
  }
  getEpclandingPageShowVehicleSelection() {
    return this.isCatalogueVisible.value ? '/epc?showVehicleSelection=true' : '/pos/customers/search';
  }
}

